import { i as jt, E as It, x as qt, d as Kt } from "./createReactComponent-58f9bea8.mjs";
import { n as G } from "./property-9daa16cd.mjs";
import { e as dt } from "./query-d94c86d2.mjs";
import { e as Et } from "./class-map-2994e95e.mjs";
const Lt = ["start", "end"], Ot = ["top", "right", "bottom", "left"].reduce((t, e) => t.concat(e, e + "-" + Lt[0], e + "-" + Lt[1]), []), U = Math.min, F = Math.max, lt = Math.round, rt = Math.floor, X = (t) => ({ x: t, y: t }), Ut = { left: "right", right: "left", bottom: "top", top: "bottom" }, Xt = { start: "end", end: "start" };
function mt(t, e, o) {
  return F(t, U(e, o));
}
function J(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function V(t) {
  return t.split("-")[0];
}
function _(t) {
  return t.split("-")[1];
}
function Dt(t) {
  return t === "x" ? "y" : "x";
}
function yt(t) {
  return t === "y" ? "height" : "width";
}
function it(t) {
  return ["top", "bottom"].includes(V(t)) ? "y" : "x";
}
function wt(t) {
  return Dt(it(t));
}
function St(t, e, o) {
  o === void 0 && (o = !1);
  const n = _(t), i = wt(t), r = yt(i);
  let l = i === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (l = at(l)), [l, at(l)];
}
function st(t) {
  return t.replace(/start|end/g, (e) => Xt[e]);
}
function at(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ut[e]);
}
function zt(t) {
  return typeof t != "number" ? function(e) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function ct(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
function Rt(t, e, o) {
  let { reference: n, floating: i } = t;
  const r = it(e), l = wt(e), a = yt(l), s = V(e), c = r === "y", h = n.x + n.width / 2 - i.width / 2, y = n.y + n.height / 2 - i.height / 2, d = n[a] / 2 - i[a] / 2;
  let m;
  switch (s) {
    case "top":
      m = { x: h, y: n.y - i.height };
      break;
    case "bottom":
      m = { x: h, y: n.y + n.height };
      break;
    case "right":
      m = { x: n.x + n.width, y };
      break;
    case "left":
      m = { x: n.x - i.width, y };
      break;
    default:
      m = { x: n.x, y: n.y };
  }
  switch (_(e)) {
    case "start":
      m[l] -= d * (o && c ? -1 : 1);
      break;
    case "end":
      m[l] += d * (o && c ? -1 : 1);
  }
  return m;
}
async function pt(t, e) {
  var o;
  e === void 0 && (e = {});
  const { x: n, y: i, platform: r, rects: l, elements: a, strategy: s } = t, { boundary: c = "clippingAncestors", rootBoundary: h = "viewport", elementContext: y = "floating", altBoundary: d = !1, padding: m = 0 } = J(e, t), p = zt(m), u = a[d ? y === "floating" ? "reference" : "floating" : y], f = ct(await r.getClippingRect({ element: (o = await (r.isElement == null ? void 0 : r.isElement(u))) == null || o ? u : u.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)), boundary: c, rootBoundary: h, strategy: s })), g = y === "floating" ? { ...l.floating, x: n, y: i } : l.reference, w = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), v = await (r.isElement == null ? void 0 : r.isElement(w)) && await (r.getScale == null ? void 0 : r.getScale(w)) || { x: 1, y: 1 }, E = ct(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: g, offsetParent: w, strategy: s }) : g);
  return { top: (f.top - E.top + p.top) / v.y, bottom: (E.bottom - f.bottom + p.bottom) / v.y, left: (f.left - E.left + p.left) / v.x, right: (E.right - f.right + p.right) / v.x };
}
const fe = function(t) {
  return t === void 0 && (t = {}), { name: "autoPlacement", options: t, async fn(e) {
    var o, n, i;
    const { rects: r, middlewareData: l, placement: a, platform: s, elements: c } = e, { crossAxis: h = !1, alignment: y, allowedPlacements: d = Ot, autoAlignment: m = !0, ...p } = J(t, e), u = y !== void 0 || d === Ot ? function(x, L, T) {
      return (x ? [...T.filter((O) => _(O) === x), ...T.filter((O) => _(O) !== x)] : T.filter((O) => V(O) === O)).filter((O) => !x || _(O) === x || !!L && st(O) !== O);
    }(y || null, m, d) : d, f = await pt(e, p), g = ((o = l.autoPlacement) == null ? void 0 : o.index) || 0, w = u[g];
    if (w == null)
      return {};
    const v = St(w, r, await (s.isRTL == null ? void 0 : s.isRTL(c.floating)));
    if (a !== w)
      return { reset: { placement: u[0] } };
    const E = [f[V(w)], f[v[0]], f[v[1]]], P = [...((n = l.autoPlacement) == null ? void 0 : n.overflows) || [], { placement: w, overflows: E }], b = u[g + 1];
    if (b)
      return { data: { index: g + 1, overflows: P }, reset: { placement: b } };
    const C = P.map((x) => {
      const L = _(x.placement);
      return [x.placement, L && h ? x.overflows.slice(0, 2).reduce((T, O) => T + O, 0) : x.overflows[0], x.overflows];
    }).sort((x, L) => x[1] - L[1]), k = ((i = C.filter((x) => x[2].slice(0, _(x[0]) ? 2 : 3).every((L) => L <= 0))[0]) == null ? void 0 : i[0]) || C[0][0];
    return k !== a ? { data: { index: g + 1, overflows: P }, reset: { placement: k } } : {};
  } };
}, Yt = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, async fn(e) {
    const { x: o, y: n } = e, i = await async function(r, l) {
      const { placement: a, platform: s, elements: c } = r, h = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), y = V(a), d = _(a), m = it(a) === "y", p = ["left", "top"].includes(y) ? -1 : 1, u = h && m ? -1 : 1, f = J(l, r);
      let { mainAxis: g, crossAxis: w, alignmentAxis: v } = typeof f == "number" ? { mainAxis: f, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...f };
      return d && typeof v == "number" && (w = d === "end" ? -1 * v : v), m ? { x: w * u, y: g * p } : { x: g * p, y: w * u };
    }(e, t);
    return { x: o + i.x, y: n + i.y, data: i };
  } };
}, he = function(t) {
  return t === void 0 && (t = {}), { name: "size", options: t, async fn(e) {
    const { placement: o, rects: n, platform: i, elements: r } = e, { apply: l = () => {
    }, ...a } = J(t, e), s = await pt(e, a), c = V(o), h = _(o), y = it(o) === "y", { width: d, height: m } = n.floating;
    let p, u;
    c === "top" || c === "bottom" ? (p = c, u = h === (await (i.isRTL == null ? void 0 : i.isRTL(r.floating)) ? "start" : "end") ? "left" : "right") : (u = c, p = h === "end" ? "top" : "bottom");
    const f = m - s[p], g = d - s[u], w = !e.middlewareData.shift;
    let v = f, E = g;
    if (y) {
      const b = d - s.left - s.right;
      E = h || w ? U(g, b) : b;
    } else {
      const b = m - s.top - s.bottom;
      v = h || w ? U(f, b) : b;
    }
    if (w && !h) {
      const b = F(s.left, 0), C = F(s.right, 0), k = F(s.top, 0), x = F(s.bottom, 0);
      y ? E = d - 2 * (b !== 0 || C !== 0 ? b + C : F(s.left, s.right)) : v = m - 2 * (k !== 0 || x !== 0 ? k + x : F(s.top, s.bottom));
    }
    await l({ ...e, availableWidth: E, availableHeight: v });
    const P = await i.getDimensions(r.floating);
    return d !== P.width || m !== P.height ? { reset: { rects: !0 } } : {};
  } };
};
function Y(t) {
  return Ft(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function $(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function j(t) {
  var e;
  return (e = (Ft(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ft(t) {
  return t instanceof Node || t instanceof $(t).Node;
}
function I(t) {
  return t instanceof Element || t instanceof $(t).Element;
}
function N(t) {
  return t instanceof HTMLElement || t instanceof $(t).HTMLElement;
}
function At(t) {
  return typeof ShadowRoot < "u" && (t instanceof ShadowRoot || t instanceof $(t).ShadowRoot);
}
function ot(t) {
  const { overflow: e, overflowX: o, overflowY: n, display: i } = W(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(i);
}
function Gt(t) {
  return ["table", "td", "th"].includes(Y(t));
}
function gt(t) {
  const e = vt(), o = W(t);
  return o.transform !== "none" || o.perspective !== "none" || !!o.containerType && o.containerType !== "normal" || !e && !!o.backdropFilter && o.backdropFilter !== "none" || !e && !!o.filter && o.filter !== "none" || ["transform", "perspective", "filter"].some((n) => (o.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (o.contain || "").includes(n));
}
function vt() {
  return !(typeof CSS > "u" || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function ft(t) {
  return ["html", "body", "#document"].includes(Y(t));
}
function W(t) {
  return $(t).getComputedStyle(t);
}
function ht(t) {
  return I(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function tt(t) {
  if (Y(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || At(t) && t.host || j(t);
  return At(e) ? e.host : e;
}
function $t(t) {
  const e = tt(t);
  return ft(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : N(e) && ot(e) ? e : $t(e);
}
function nt(t, e, o) {
  var n;
  e === void 0 && (e = []), o === void 0 && (o = !0);
  const i = $t(t), r = i === ((n = t.ownerDocument) == null ? void 0 : n.body), l = $(i);
  return r ? e.concat(l, l.visualViewport || [], ot(i) ? i : [], l.frameElement && o ? nt(l.frameElement) : []) : e.concat(i, nt(i, [], o));
}
function Bt(t) {
  const e = W(t);
  let o = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = N(t), r = i ? t.offsetWidth : o, l = i ? t.offsetHeight : n, a = lt(o) !== r || lt(n) !== l;
  return a && (o = r, n = l), { width: o, height: n, $: a };
}
function xt(t) {
  return I(t) ? t : t.contextElement;
}
function Z(t) {
  const e = xt(t);
  if (!N(e))
    return X(1);
  const o = e.getBoundingClientRect(), { width: n, height: i, $: r } = Bt(e);
  let l = (r ? lt(o.width) : o.width) / n, a = (r ? lt(o.height) : o.height) / i;
  return l && Number.isFinite(l) || (l = 1), a && Number.isFinite(a) || (a = 1), { x: l, y: a };
}
const Jt = X(0);
function Mt(t) {
  const e = $(t);
  return vt() && e.visualViewport ? { x: e.visualViewport.offsetLeft, y: e.visualViewport.offsetTop } : Jt;
}
function Q(t, e, o, n) {
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), r = xt(t);
  let l = X(1);
  e && (n ? I(n) && (l = Z(n)) : l = Z(t));
  const a = function(d, m, p) {
    return m === void 0 && (m = !1), !(!p || m && p !== $(d)) && m;
  }(r, o, n) ? Mt(r) : X(0);
  let s = (i.left + a.x) / l.x, c = (i.top + a.y) / l.y, h = i.width / l.x, y = i.height / l.y;
  if (r) {
    const d = $(r), m = n && I(n) ? $(n) : n;
    let p = d.frameElement;
    for (; p && n && m !== d; ) {
      const u = Z(p), f = p.getBoundingClientRect(), g = W(p), w = f.left + (p.clientLeft + parseFloat(g.paddingLeft)) * u.x, v = f.top + (p.clientTop + parseFloat(g.paddingTop)) * u.y;
      s *= u.x, c *= u.y, h *= u.x, y *= u.y, s += w, c += v, p = $(p).frameElement;
    }
  }
  return ct({ width: h, height: y, x: s, y: c });
}
function Wt(t) {
  return Q(j(t)).left + ht(t).scrollLeft;
}
function Pt(t, e, o) {
  let n;
  if (e === "viewport")
    n = function(i, r) {
      const l = $(i), a = j(i), s = l.visualViewport;
      let c = a.clientWidth, h = a.clientHeight, y = 0, d = 0;
      if (s) {
        c = s.width, h = s.height;
        const m = vt();
        (!m || m && r === "fixed") && (y = s.offsetLeft, d = s.offsetTop);
      }
      return { width: c, height: h, x: y, y: d };
    }(t, o);
  else if (e === "document")
    n = function(i) {
      const r = j(i), l = ht(i), a = i.ownerDocument.body, s = F(r.scrollWidth, r.clientWidth, a.scrollWidth, a.clientWidth), c = F(r.scrollHeight, r.clientHeight, a.scrollHeight, a.clientHeight);
      let h = -l.scrollLeft + Wt(i);
      const y = -l.scrollTop;
      return W(a).direction === "rtl" && (h += F(r.clientWidth, a.clientWidth) - s), { width: s, height: c, x: h, y };
    }(j(t));
  else if (I(e))
    n = function(i, r) {
      const l = Q(i, !0, r === "fixed"), a = l.top + i.clientTop, s = l.left + i.clientLeft, c = N(i) ? Z(i) : X(1);
      return { width: i.clientWidth * c.x, height: i.clientHeight * c.y, x: s * c.x, y: a * c.y };
    }(e, o);
  else {
    const i = Mt(t);
    n = { ...e, x: e.x - i.x, y: e.y - i.y };
  }
  return ct(n);
}
function _t(t, e) {
  const o = tt(t);
  return !(o === e || !I(o) || ft(o)) && (W(o).position === "fixed" || _t(o, e));
}
function Qt(t, e, o) {
  const n = N(e), i = j(e), r = o === "fixed", l = Q(t, !0, r, e);
  let a = { scrollLeft: 0, scrollTop: 0 };
  const s = X(0);
  if (n || !n && !r)
    if ((Y(e) !== "body" || ot(i)) && (a = ht(e)), n) {
      const c = Q(e, !0, r, e);
      s.x = c.x + e.clientLeft, s.y = c.y + e.clientTop;
    } else
      i && (s.x = Wt(i));
  return { x: l.left + a.scrollLeft - s.x, y: l.top + a.scrollTop - s.y, width: l.width, height: l.height };
}
function kt(t, e) {
  return N(t) && W(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function Ct(t, e) {
  const o = $(t);
  if (!N(t))
    return o;
  let n = kt(t, e);
  for (; n && Gt(n) && W(n).position === "static"; )
    n = kt(n, e);
  return n && (Y(n) === "html" || Y(n) === "body" && W(n).position === "static" && !gt(n)) ? o : n || function(i) {
    let r = tt(i);
    for (; N(r) && !ft(r); ) {
      if (gt(r))
        return r;
      r = tt(r);
    }
    return null;
  }(t) || o;
}
const Zt = { convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: o, strategy: n } = t;
  const i = N(o), r = j(o);
  if (o === r)
    return e;
  let l = { scrollLeft: 0, scrollTop: 0 }, a = X(1);
  const s = X(0);
  if ((i || !i && n !== "fixed") && ((Y(o) !== "body" || ot(r)) && (l = ht(o)), N(o))) {
    const c = Q(o);
    a = Z(o), s.x = c.x + o.clientLeft, s.y = c.y + o.clientTop;
  }
  return { width: e.width * a.x, height: e.height * a.y, x: e.x * a.x - l.scrollLeft * a.x + s.x, y: e.y * a.y - l.scrollTop * a.y + s.y };
}, getDocumentElement: j, getClippingRect: function(t) {
  let { element: e, boundary: o, rootBoundary: n, strategy: i } = t;
  const r = [...o === "clippingAncestors" ? function(s, c) {
    const h = c.get(s);
    if (h)
      return h;
    let y = nt(s, [], !1).filter((u) => I(u) && Y(u) !== "body"), d = null;
    const m = W(s).position === "fixed";
    let p = m ? tt(s) : s;
    for (; I(p) && !ft(p); ) {
      const u = W(p), f = gt(p);
      f || u.position !== "fixed" || (d = null), (m ? !f && !d : !f && u.position === "static" && d && ["absolute", "fixed"].includes(d.position) || ot(p) && !f && _t(s, p)) ? y = y.filter((g) => g !== p) : d = u, p = tt(p);
    }
    return c.set(s, y), y;
  }(e, this._c) : [].concat(o), n], l = r[0], a = r.reduce((s, c) => {
    const h = Pt(e, c, i);
    return s.top = F(h.top, s.top), s.right = U(h.right, s.right), s.bottom = U(h.bottom, s.bottom), s.left = F(h.left, s.left), s;
  }, Pt(e, l, i));
  return { width: a.right - a.left, height: a.bottom - a.top, x: a.left, y: a.top };
}, getOffsetParent: Ct, getElementRects: async function(t) {
  let { reference: e, floating: o, strategy: n } = t;
  const i = this.getOffsetParent || Ct, r = this.getDimensions;
  return { reference: Qt(e, await i(o), n), floating: { x: 0, y: 0, ...await r(o) } };
}, getClientRects: function(t) {
  return Array.from(t.getClientRects());
}, getDimensions: function(t) {
  return Bt(t);
}, getScale: Z, isElement: I, isRTL: function(t) {
  return W(t).direction === "rtl";
} };
function te(t, e, o, n) {
  n === void 0 && (n = {});
  const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = typeof ResizeObserver == "function", layoutShift: a = typeof IntersectionObserver == "function", animationFrame: s = !1 } = n, c = xt(t), h = i || r ? [...c ? nt(c) : [], ...nt(e)] : [];
  h.forEach((f) => {
    i && f.addEventListener("scroll", o, { passive: !0 }), r && f.addEventListener("resize", o);
  });
  const y = c && a ? function(f, g) {
    let w, v = null;
    const E = j(f);
    function P() {
      clearTimeout(w), v && v.disconnect(), v = null;
    }
    return function b(C, k) {
      C === void 0 && (C = !1), k === void 0 && (k = 1), P();
      const { left: x, top: L, width: T, height: O } = f.getBoundingClientRect();
      if (C || g(), !T || !O)
        return;
      const q = { rootMargin: -rt(L) + "px " + -rt(E.clientWidth - (x + T)) + "px " + -rt(E.clientHeight - (L + O)) + "px " + -rt(x) + "px", threshold: F(0, U(1, k)) || 1 };
      let K = !0;
      function R(S) {
        const A = S[0].intersectionRatio;
        if (A !== k) {
          if (!K)
            return b();
          A ? b(!1, A) : w = setTimeout(() => {
            b(!1, 1e-7);
          }, 100);
        }
        K = !1;
      }
      try {
        v = new IntersectionObserver(R, { ...q, root: E.ownerDocument });
      } catch {
        v = new IntersectionObserver(R, q);
      }
      v.observe(f);
    }(!0), P;
  }(c, o) : null;
  let d, m = -1, p = null;
  l && (p = new ResizeObserver((f) => {
    let [g] = f;
    g && g.target === c && p && (p.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      p && p.observe(e);
    })), o();
  }), c && !s && p.observe(c), p.observe(e));
  let u = s ? Q(t) : null;
  return s && function f() {
    const g = Q(t);
    !u || g.x === u.x && g.y === u.y && g.width === u.width && g.height === u.height || o(), u = g, d = requestAnimationFrame(f);
  }(), o(), () => {
    h.forEach((f) => {
      i && f.removeEventListener("scroll", o), r && f.removeEventListener("resize", o);
    }), y && y(), p && p.disconnect(), p = null, s && cancelAnimationFrame(d);
  };
}
const ee = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), i = { platform: Zt, ...o }, r = { ...i.platform, _c: n };
  return (async (l, a, s) => {
    const { placement: c = "bottom", strategy: h = "absolute", middleware: y = [], platform: d } = s, m = y.filter(Boolean), p = await (d.isRTL == null ? void 0 : d.isRTL(a));
    let u = await d.getElementRects({ reference: l, floating: a, strategy: h }), { x: f, y: g } = Rt(u, c, p), w = c, v = {}, E = 0;
    for (let P = 0; P < m.length; P++) {
      const { name: b, fn: C } = m[P], { x: k, y: x, data: L, reset: T } = await C({ x: f, y: g, initialPlacement: c, placement: w, strategy: h, middlewareData: v, rects: u, platform: d, elements: { reference: l, floating: a } });
      f = k ?? f, g = x ?? g, v = { ...v, [b]: { ...v[b], ...L } }, T && E <= 50 && (E++, typeof T == "object" && (T.placement && (w = T.placement), T.rects && (u = T.rects === !0 ? await d.getElementRects({ reference: l, floating: a, strategy: h }) : T.rects), { x: f, y: g } = Rt(u, w, p)), P = -1);
    }
    return { x: f, y: g, placement: w, strategy: h, middlewareData: v };
  })(t, e, { ...i, platform: r });
}, oe = jt`
  :host {
    --exo-component-tooltip-arrow-size: var(--exo-radius-standard);
    --exo-component-tooltip-arrow-size-diagonal: calc(
      var(--exo-component-tooltip-arrow-size) * 0.7071
    );
    --exo-component-tooltip-arrow-padding-offset: calc(
      var(--exo-component-tooltip-arrow-size-diagonal) - var(
          --exo-component-tooltip-arrow-size
        )
    );
    display: contents;
  }
  .popup {
    position: absolute;
    isolation: isolate;
    z-index: var(--exo-z-index-tooltip-popup);
  }
  .popup--fixed {
    position: fixed;
  }
  .popup:not(.popup--active) {
    transform: scale(0);
  }
  .popup.popup--active {
    transform: scale(1);
  }
  .popup__arrow {
    position: absolute;
    width: calc(var(--exo-component-tooltip-arrow-size-diagonal) * 4);
    height: calc(var(--exo-component-tooltip-arrow-size-diagonal) * 4);
    transform: rotate(45deg);
    background: var(--exo-color-background-action-inverse);
    z-index: -1;
  }

  .tooltip::part(popup) {
    z-index: 1;
  }
  .tooltip[placement^="top"]::part(popup) {
    transform-origin: bottom;
  }
  .tooltip[placement^="bottom"]::part(popup) {
    transform-origin: top;
  }
  .tooltip[placement^="left"]::part(popup) {
    transform-origin: right;
  }
  .tooltip[placement^="right"]::part(popup) {
    transform-origin: left;
  }
  .tooltip__body {
    width: max-content;
    max-width: var(--exo-size-3);
    padding: var(--exo-spacing-x-small) var(--exo-spacing-small);
    font-family: var(--exo-font-family);
    color: var(--exo-color-font-inverse);
    background-color: var(--exo-color-background-action-inverse);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-inverse);
    font-weight: var(--exo-font-weight-regular);
    font-size: var(--exo-font-size-micro);
    line-height: var(--exo-line-height-body);
    border-radius: calc(2 * var(--exo-radius-small));
    white-space: normal;
  }

  .tooltip {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
  }
`;
var ne = Object.defineProperty, ie = Object.getOwnPropertyDescriptor, H = (t, e, o, n) => {
  for (var i, r = n > 1 ? void 0 : n ? ie(e, o) : e, l = t.length - 1; l >= 0; l--)
    (i = t[l]) && (r = (n ? i(e, o, r) : i(r)) || r);
  return n && r && ne(e, o, r), r;
}, re = ((t) => (t.TOP = "top", t.BOTTOM = "bottom", t.RIGHT = "right", t.LEFT = "left", t))(re || {}), se = ((t) => (t.START = "start", t.MIDDLE = "middle", t.END = "end", t))(se || {});
class M extends It {
  constructor() {
    super(...arguments), this.active = !0, this.position = "top", this.alignment = "start", this.trigger = "hover focus", this.open = !1, this.tooltipDelay = 0, this.tooltipTimeout = null, this.placement = "top", this.arrowPadding = 6, this.showTooltipOnOverflow = !1, this.disable = !1, this.handleKeyDown = (e) => {
      this.open && e.key === "Escape" && (e.stopPropagation(), this.hide());
    };
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start(), this.updateComplete.then(() => {
      this.addEventListener("blur", this.handleBlur, !0), this.addEventListener("focus", this.handleFocus, !0), this.addEventListener("mouseover", this.handleMouseOver), this.addEventListener("mouseout", this.handleMouseOut), this.addEventListener("click", this.handleClick), document.addEventListener("keydown", this.handleKeyDown);
    });
  }
  disconnectedCallback() {
    this.stop(), this.removeEventListener("blur", this.handleBlur, !0), this.removeEventListener("focus", this.handleFocus, !0), this.removeEventListener("mouseover", this.handleMouseOver), this.removeEventListener("mouseout", this.handleMouseOut), this.removeEventListener("click", this.handleClick), document.removeEventListener("keydown", this.handleKeyDown);
  }
  async handleAnchorChange() {
    await this.stop(), this.anchorEl = this.querySelector('[slot="anchor"]'), this.start();
  }
  start() {
    this.anchorEl && (this.cleanup = te(this.anchorEl, this.popup, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((e) => {
      this.cleanup && (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement")), e();
    });
  }
  firstUpdated() {
    this.body.hidden = !this.open, this.open && (this.active = !0, this.reposition()), this.handleOpenChange(), this.handleOptionsChange(), this.handleAnchorChange();
  }
  updated(e) {
    super.updated(e), this.active && this.reposition(), e.has("open") && this.hasTrigger("click") && (this.open ? this.show() : this.hide());
  }
  reposition() {
    if (!this.active || !this.anchorEl)
      return;
    const e = [Yt({ mainAxis: 7, crossAxis: 0 })];
    var o;
    this.popup.style.width = "", this.popup.style.height = "", e.push(function(n) {
      return n === void 0 && (n = {}), { name: "flip", options: n, async fn(i) {
        var r, l;
        const { placement: a, middlewareData: s, rects: c, initialPlacement: h, platform: y, elements: d } = i, { mainAxis: m = !0, crossAxis: p = !0, fallbackPlacements: u, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: w = !0, ...v } = J(n, i);
        if ((r = s.arrow) != null && r.alignmentOffset)
          return {};
        const E = V(a), P = V(h) === h, b = await (y.isRTL == null ? void 0 : y.isRTL(d.floating)), C = u || (P || !w ? [at(h)] : function(R) {
          const S = at(R);
          return [st(R), S, st(S)];
        }(h));
        u || g === "none" || C.push(...function(R, S, A, B) {
          const z = _(R);
          let D = function(et, ut, Ht) {
            const bt = ["left", "right"], Tt = ["right", "left"], Vt = ["top", "bottom"], Nt = ["bottom", "top"];
            switch (et) {
              case "top":
              case "bottom":
                return Ht ? ut ? Tt : bt : ut ? bt : Tt;
              case "left":
              case "right":
                return ut ? Vt : Nt;
              default:
                return [];
            }
          }(V(R), A === "start", B);
          return z && (D = D.map((et) => et + "-" + z), S && (D = D.concat(D.map(st)))), D;
        }(h, w, g, b));
        const k = [h, ...C], x = await pt(i, v), L = [];
        let T = ((l = s.flip) == null ? void 0 : l.overflows) || [];
        if (m && L.push(x[E]), p) {
          const R = St(a, c, b);
          L.push(x[R[0]], x[R[1]]);
        }
        if (T = [...T, { placement: a, overflows: L }], !L.every((R) => R <= 0)) {
          var O, q;
          const R = (((O = s.flip) == null ? void 0 : O.index) || 0) + 1, S = k[R];
          if (S)
            return { data: { index: R, overflows: T }, reset: { placement: S } };
          let A = (q = T.filter((B) => B.overflows[0] <= 0).sort((B, z) => B.overflows[1] - z.overflows[1])[0]) == null ? void 0 : q.placement;
          if (!A)
            switch (f) {
              case "bestFit": {
                var K;
                const B = (K = T.map((z) => [z.placement, z.overflows.filter((D) => D > 0).reduce((D, et) => D + et, 0)]).sort((z, D) => z[1] - D[1])[0]) == null ? void 0 : K[0];
                B && (A = B);
                break;
              }
              case "initialPlacement":
                A = h;
            }
          if (a !== A)
            return { reset: { placement: A } };
        }
        return {};
      } };
    }({ boundary: [], fallbackPlacements: "", fallbackStrategy: "bestFit", padding: 0 })), e.push(((o = { boundary: [], padding: 0 }) === void 0 && (o = {}), { name: "shift", options: o, async fn(n) {
      const { x: i, y: r, placement: l } = n, { mainAxis: a = !0, crossAxis: s = !1, limiter: c = { fn: (w) => {
        let { x: v, y: E } = w;
        return { x: v, y: E };
      } }, ...h } = J(o, n), y = { x: i, y: r }, d = await pt(n, h), m = it(V(l)), p = Dt(m);
      let u = y[p], f = y[m];
      if (a) {
        const w = p === "y" ? "bottom" : "right";
        u = mt(u + d[p === "y" ? "top" : "left"], u, u - d[w]);
      }
      if (s) {
        const w = m === "y" ? "bottom" : "right";
        f = mt(f + d[m === "y" ? "top" : "left"], f, f - d[w]);
      }
      const g = c.fn({ ...n, [p]: u, [m]: f });
      return { ...g, data: { x: g.x - i, y: g.y - r } };
    } })), e.push(((n) => ({ name: "arrow", options: n, async fn(i) {
      const { x: r, y: l, placement: a, rects: s, platform: c, elements: h, middlewareData: y } = i, { element: d, padding: m = 0 } = J(n, i) || {};
      if (d == null)
        return {};
      const p = zt(m), u = { x: r, y: l }, f = wt(a), g = yt(f), w = await c.getDimensions(d), v = f === "y", E = v ? "top" : "left", P = v ? "bottom" : "right", b = v ? "clientHeight" : "clientWidth", C = s.reference[g] + s.reference[f] - u[f] - s.floating[g], k = u[f] - s.reference[f], x = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(d));
      let L = x ? x[b] : 0;
      L && await (c.isElement == null ? void 0 : c.isElement(x)) || (L = h.floating[b] || s.floating[g]);
      const T = C / 2 - k / 2, O = L / 2 - w[g] / 2 - 1, q = U(p[E], O), K = U(p[P], O), R = q, S = L - w[g] - K, A = L / 2 - w[g] / 2 + T, B = mt(R, A, S), z = !y.arrow && _(a) != null && A != B && s.reference[g] / 2 - (A < R ? q : K) - w[g] / 2 < 0, D = z ? A < R ? A - R : A - S : 0;
      return { [f]: u[f] + D, data: { [f]: B, centerOffset: A - B - D, ...z && { alignmentOffset: D } }, reset: z };
    } }))({ element: this.arrowEl, padding: this.arrowPadding })), this.placement = `${this.position}-${this.alignment}`, ee(this.anchorEl, this.popup, { placement: this.placement, middleware: e, strategy: "fixed" }).then(({ x: n, y: i, middlewareData: r, placement: l }) => {
      const a = getComputedStyle(this).direction === "rtl", s = { top: "bottom", right: "left", bottom: "top", left: "right" }[l.split("-")[0]];
      if (this.setAttribute("data-current-placement", l), Object.assign(this.popup.style, { left: `${n}px`, top: `${i}px` }), r.arrow) {
        const c = r.arrow.x, h = r.arrow.y;
        let y = "", d = "", m = "", p = "";
        this.alignment === "start" ? { top: y, right: d, left: p } = this.setPositionsForStartAlignment(c, h, a) : this.alignment === "end" ? { bottom: m, right: d, left: p } = this.setPositionsForEndAlignment(c, h, a) : this.alignment === "middle" && ({ left: p, top: y } = function(u, f) {
          return { left: typeof u == "number" ? "calc(50% - var(--exo-component-tooltip-arrow-size-diagonal) - 3px)" : "", top: typeof f == "number" ? "calc(50% - var(--exo-component-tooltip-arrow-size-diagonal) - 3px)" : "" };
        }(c, h)), Object.assign(this.arrowEl.style, { top: y, right: d, bottom: m, left: p, [s]: "calc(var(--exo-component-tooltip-arrow-size-diagonal) * -1)", display: "block" });
      } else
        this.arrowEl && (this.arrowEl.style.display = "none");
    });
  }
  setPositionsForStartAlignment(e, o, n) {
    const i = typeof e == "number" ? `calc(${this.arrowPadding}px - var(--exo-component-tooltip-arrow-padding-offset))` : "";
    return { top: typeof o == "number" ? `calc(${this.arrowPadding}px - var(--exo-component-tooltip-arrow-padding-offset))` : "", right: n ? i : "", left: n ? "" : i };
  }
  setPositionsForEndAlignment(e, o, n) {
    const i = typeof e == "number" ? `calc(${this.arrowPadding}px - var(--exo-component-tooltip-arrow-padding-offset))` : "";
    return { right: n ? "" : i, left: n ? i : "", bottom: typeof o == "number" ? `calc(${this.arrowPadding}px - var(--exo-component-tooltip-arrow-padding-offset))` : "" };
  }
  shouldShow() {
    var e;
    if (this.disable)
      return !1;
    if (this.showTooltipOnOverflow) {
      const o = (e = this.shadowRoot) == null ? void 0 : e.querySelector(".tooltip");
      return o && o.scrollWidth > o.clientWidth;
    }
    return !0;
  }
  show() {
    return this.shouldShow() && (this.open = !0, this.handleOpenChange()), !1;
  }
  hide() {
    return this.open = !1, this.handleOpenChange(), !1;
  }
  handleBlur() {
    this.hasTrigger("focus") && this.hide();
  }
  handleFocus() {
    this.hasTrigger("focus") && this.show();
  }
  handleMouseOver() {
    this.hasTrigger("hover") && (this.tooltipTimeout = setTimeout(() => {
      this.show();
    }, 1e3 * this.tooltipDelay));
  }
  handleMouseOut() {
    this.hasTrigger("hover") && (this.tooltipTimeout && (clearTimeout(this.tooltipTimeout), this.tooltipTimeout = null), this.hide());
  }
  handleClick() {
    this.hasTrigger("click") && (this.open ? this.hide() : this.show());
  }
  async handleOpenChange() {
    this.open ? (this.body.hidden = !1, this.active = !0) : (this.active = !1, this.body.hidden = !0);
  }
  async handleOptionsChange() {
    this.hasUpdated && (await this.updateComplete, this.reposition());
  }
  hasTrigger(e) {
    return this.trigger.split(" ").includes(e);
  }
  render() {
    return qt`
      <span
        class=${Et({ tooltip: !0, "tooltip--open": this.open })}
        part="tooltip"
        placement=${this.placement}
        distance=${7}
        skidding=${0}
        hoist
        strategy="fixed"
        flip
        shift
        arrow
      >
        <slot
          name="anchor"
          @slotchange=${this.handleAnchorChange}
          aria-describedby="tooltip"
        ></slot>
        <div
          part="popup"
          class=${Et({ popup: !0, "popup--active": this.active === !0, "popup--fixed": !0, "popup--has-arrow": !0 })}
        >
          <div
            part="body"
            id="tooltip"
            class="tooltip__body"
            role="tooltip"
            aria-hidden=${this.open ? "false" : "true"}
          >
            <slot name="content" aria-live=${this.open ? "polite" : "off"}>
              <slot></slot>
              <div part="arrow" class="popup__arrow" role="presentation"></div>
            </slot>
          </div>
        </div>
      </span>
    `;
  }
}
M.styles = oe, H([dt(".popup")], M.prototype, "popup", 2), H([dt(".popup__arrow")], M.prototype, "arrowEl", 2), H([dt(".tooltip__body")], M.prototype, "body", 2), H([G({ reflect: !0 })], M.prototype, "position", 2), H([G({ reflect: !0 })], M.prototype, "alignment", 2), H([G()], M.prototype, "trigger", 2), H([G({ type: Boolean, reflect: !0 })], M.prototype, "open", 2), H([G({ type: Number })], M.prototype, "tooltipDelay", 2), H([G({ type: Boolean, reflect: !0 })], M.prototype, "showTooltipOnOverflow", 2), H([G({ type: Boolean, reflect: !0 })], M.prototype, "disable", 2);
const ue = Kt("ex-tooltip", M);
export {
  se as T,
  re as a,
  M as b,
  ee as c,
  te as d,
  fe as e,
  Yt as o,
  ue as r,
  he as s
};
